import Tribute from "tributejs";
import Dropzone from "dropzone";
import MessagingHelpers from "./helpers";
import scrollChatDown from "./scroll_chat_down";

export default function ChatHandler(chat) {
  this.helpers = new MessagingHelpers();
  this.forbiddenFormats = /\.(app|bat|action|bin|csh|exe|ksh|sh|out|run|pyc|pyo|rb)$/i;
  this.uploadedFiles = [];

  this.renderSelectedFiles = () => {
    $("#attached-files").empty();
    this.uploadedFiles.forEach((file, index) => {
      const newFile = `
        <span class="attached-file-new">
        <img src="/icons/paperclip_png.png" class="paperclip-icon"/>
          ${file.name}
          <span class="delete-attachment" data-index="${index}">x</span>
        </span>
      `;
      $("#attached-files").append(newFile);
    });
  };

  this.invalidFormatHandler = (file) => {
    $("#error-messages").append(`
      <div class="invalid-extension-error">Invalid File extension at ${file.name}</div>
    `);

    setTimeout(() => {
      $("#error-messages").empty();
    }, 3000);
  };

  this.initializeInsertion = () => {
    const input = document.getElementById("comment-input");
    const dataSource = `/admin/chats/${chat.chatId}/mentionables.json`;

    this.tribute = new Tribute({
      collection: [
        {
          trigger: "@",
          values: function (text, cb) {
            $.get(dataSource, (result) => cb(result));
          },
          lookup: "name",
          selectTemplate: (item) => {
            return `<span contenteditable="false" class="atwho-custom" data-atwho-id="${item.original.id}" data-atwho-type="${item.original.user_type}">@${item.original.name}</span>`;
          },
        },
        {
          trigger: "/",
          values: function (text, cb) {
            $.get(`/admin/chats/${chat.chatId}/commands.json`, (result) => cb(result));
          },
          lookup: "name",
          selectTemplate: (item) => {
            return `
              <span class="atwho-command" data-atwho-type="COMMAND" contenteditable="false">
                /${item.original.name}
              </span>
              `.trim();
          },
        },
        {
          trigger: "~",
          allowSpaces: true,
          values: function (text, cb) {
            $.get(
              {
                url: "/admin/message_templates.json",
                headers: { Accept: "application/json" },
              },
              (result) => cb(result)
            );
          },
          lookup: "name",
          selectTemplate: (item) => {
            // Replace command strings with actual command tags
            return item.original.content.replace(
              /^(\/\w+)\s/,
              `<span class="atwho-command" data-atwho-type="COMMAND" contenteditable="false">
                $1
              </span>`.trim()
            );
          },
        },
      ],
    });
    this.tribute.attach(input);
  };

  this.extractMentionedUserIds = (inputElement) => {
    const mentionedUserIds = [];
    inputElement.find(".atwho-custom[data-atwho-type='User']").each(function () {
      const userId = $(this).data("atwho-id");
      if (userId && !mentionedUserIds.includes(userId)) {
        mentionedUserIds.push(userId);
      }
    });
    return mentionedUserIds;
  };

  this.postNewComment = (_e) => {
    const input = $("#comment-input");
    input.focus();

    if (!input.text().trim() && !this.uploadedFiles.length) {
      return;
    }

    this.disableInput();

    const message = input.html();
    const mentionedUserIds = this.extractMentionedUserIds(input);
    const formData = new FormData();
    formData.append("chat_comment[content]", this.helpers.safeHtml(message));
    if ($("#reply_comment_id").val()) {
      formData.append("chat_comment[answered_comment_id]", $("#reply_comment_id").val());
    }

    mentionedUserIds.forEach((userId) => {
      formData.append("chat_comment[mentioned_user_ids][]", userId);
    });

    this.uploadedFiles.forEach((file, i) => {
      formData.append(`chat_comment[comment_attachments_attributes][${i}][file]`, file);
    });

    const reloadDocumentsForm = !!this.uploadedFiles.length;

    this.uploadedFiles = [];
    input.empty();
    $("#attached-files").empty();
    $("#file-input").val("");
    $("#reply-comment-container").empty();

    $.ajax({
      url: `/admin/chats/${chat.chatId}/chat_comments`,
      processData: false,
      contentType: false,
      method: "POST",
      enctype: "multipart/form-data",
      data: formData,
      success: () => {
        console.log(`posted a comment to chat=${chat.chatId}`);
        this.enableInput();

        if (reloadDocumentsForm) {
          $("#chat-documents").load(`/admin/chats/${chat.chatId}/chat_attachments`, () => {
            // Reinitialize the attached JS
            $("#chat-documents select").select2();
            chat.chatDocumentManager.reinitialize();
          });
        }
      },
    });
  };

  this.disableInput = () => {
    $("#comment-input-container").addClass("disabled");
    $("#submit-comment-button").addClass("disabled");
  };

  this.enableInput = () => {
    $("#comment-input-container").removeClass("disabled");
    $("#submit-comment-button").removeClass("disabled");
    $("#comment-input").focus();
  };

  this.initDropzone = () => {
    Dropzone.autoDiscover = false;
    $(".dropzone-attachments").each((i, element) => {
      new Dropzone(element, {
        url: "/chat_comments/atachments",
        autoQueue: false,
        autoProcessQueue: false,
        uploadMultiple: false,
        addRemoveLinks: false,
        parallelUploads: 1,
        maxFilesize: 50, // MB
        createImageThumbnails: false,
        clickable: $(element).find(".dragzone-clickable").get(0),
        accept: (file, done) => {
          if (this.forbiddenFormats.test(file.name)) {
            this.invalidFormatHandler(file);
            done("Invalid format.");
          } else {
            this.uploadedFiles.push(file);
          }
        },
        addedfile: () => setTimeout(() => this.renderSelectedFiles(), 500),
      });
    });
  };

  this.initializeEventListeners = () => {
    let container = $("#chat-container");
    let input = $("#comment-input");

    container.on("change", "#file-input", (e) => {
      if (!e.target.files) {
        return;
      }
      for (let file of e.target.files) {
        this.forbiddenFormats.test(file.name)
          ? this.invalidFormatHandler(file)
          : this.uploadedFiles.push(file);
      }
      this.renderSelectedFiles();
    });

    input
      .on("focus", () => $("#comment-input-container").addClass("active"))
      .on("blur", () => $("#comment-input-container").removeClass("active"));

    input.on("keydown", (e) => {
      if (e.keyCode !== 13 || e.shiftKey || this.tribute.isActive) {
        return;
      }
      e.preventDefault();
      this.postNewComment(e);
    });

    container.on("click", "#submit-comment-button", (e) => {
      e.preventDefault();
      this.postNewComment(e);
    });

    input.on("input", (e) => {
      let input = e.currentTarget;
      // clear the <br> that seems to appear in an empty box
      if (input.textContent === "") {
        input.innerHTML = "";
      }
    });

    input.on("paste", this.helpers.safePaste);

    container.on("click", ".delete-reply", () => $("#reply-comment-container").empty());

    container.on("click", ".reply-icon", (e) => {
      $("#reply-comment-container").empty();
      let comment = $(e.currentTarget).parents(".comment-item");
      let content = comment.find("p.comment-content");
      const commentId = comment.data("commentId");

      let quote = `
        <div class="reply-comment w-50 d-flex px-2 mb-2">
          ${content.html()}
          <span class="delete-reply ml-auto">&times;</span>
          <input type="hidden" id="reply_comment_id" value="${commentId}"/>
        </div>`;

      $("#reply-comment-container").append(quote);
      scrollChatDown();
      $("#comment-input").focus();
    });

    container.on("click", ".delete-attachment", (e) => {
      const index = $(".attached-file-new").index(e.target.parentElement);
      this.uploadedFiles.splice(index, 1);
      $(e.target).parent().remove();
    });
  };

  this.initializeInsertion();
  this.initializeEventListeners();
  this.enableInput();
  this.initDropzone();
}
